module.exports = __webpack_public_path__ + "static/media/Icon_1.3ae98e54.svg";